/**
 * Constants for Search Result Listing Page
 */

export const SEARCH_REQUEST_ID_HEADER = 'x-search-request-id'

export enum SectionType {
    PRIMARY = 'primary',
    SEVERED_FILLUP = 'severed-fillup',
    FILLUP = 'fillup',
    PARTNER = 'partner',
}

export enum DataSource {
    MAIN = 'main',
    HOLIDU = 'holidu',
    HOMETOGO = 'hometogo',
}

export const LAYOUT = {
    HEADER_HEIGHT: 5, // rem
    STICKY_GAP: 1, // rem
    MAP_HEIGHT: 4.5, // rem
    SMALL_SIDEBAR_WIDTH: 14, // rem
    SIDEBAR_WIDTH: 17.625, // rem
} as const

export const PAGINATION = {
    ITEMS_PER_PAGE: 24,
} as const

export const SKELETON_FILTERS = {
    POPULAR_ITEMS_COUNT: 2,
    FILTER_ITEMS_COUNT: 2,
    FILTER_SECTIONS_COUNT: 2,
} as const

export const LIST_VIEW_CONFIG = {
    SKELETON_COUNT: 6,
    AUTO_LOAD_THRESHOLD: 5,
    GRID_ITEMS_PER_ROW: 3,
    TABLET_GRID_ITEMS_PER_ROW: 2,
    LIST_ITEMS_PER_ROW: 1,
    MOBILE_ITEMS_PER_ROW: 1,
} as const

export enum SECTION_MERGE_KEYS {
    SKELETON = 'skeleton',
    PRIMARY_MAIN = 'primary_main',
    SEVERED_FILLUP_MAIN = 'severed-fillup_main',
    FILLUP_MAIN = 'fillup_main',
    PARTNER_HOLIDU = 'partner_holidu',
    PARTNER_HOMETOGO = 'partner_hometogo',
}

export const SECTION_DISPLAY_ORDER = [
    SECTION_MERGE_KEYS.PRIMARY_MAIN,
    SECTION_MERGE_KEYS.SEVERED_FILLUP_MAIN,
    SECTION_MERGE_KEYS.FILLUP_MAIN,
    SECTION_MERGE_KEYS.PARTNER_HOLIDU,
    SECTION_MERGE_KEYS.PARTNER_HOMETOGO,
]

export const getMergeKey = (type: SectionType, source: DataSource): SECTION_MERGE_KEYS => {
    const key = `${type}_${source}` as SECTION_MERGE_KEYS

    if (Object.values(SECTION_MERGE_KEYS).includes(key)) {
        return key
    }

    return SECTION_MERGE_KEYS.PRIMARY_MAIN
}
